
export const restructorData = (data, len) => {
  let i = 0,
    size = 0;
  let newData = [];
  let main = [];
  while (i <= data.length) {
    if (size < len) {
      if (data[i] !== undefined) main.push(data[i]);
      size++;
      i++;
    } else {
      size = 0;
      newData.push(main);
      main = [];
    }
  }
  if (main.length !== 0) {
    newData.push(main);
  }
  return newData;
};
export const formatDate = (date) => {
  if (!date) {
    return ""
  }
  let dateString = new Date(date);
  dateString = dateString.toUTCString();
  dateString = dateString.split(' ').slice(0, 4).join(' ');
  dateString = dateString.split(",")[1];
  dateString = dateString.split(" ");
  return dateString = dateString[2] + " " + (dateString[1].charAt(0) === "0" ? dateString[1].charAt(1) : dateString[1]) + ", " + dateString[3]

}
